if (!customElements.get('bogo-cart-sync')) {
  customElements.define(
    'bogo-cart-sync',
    class BogoCartSync extends HTMLElement {
      connectedCallback() {
        this.caseQuantityInCart = 0;
        this.caseProductType = this.dataset.productType || 'Kindle Case';
        this.unsubscribeCartUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        const gridContainer = document.getElementById('ProductGridContainer');
        if (gridContainer) {
          this.gridObserver = new MutationObserver(() => this.applyState());
          this.gridObserver.observe(gridContainer, { childList: true, subtree: true });
        }
        this.refresh();
      }

      disconnectedCallback() {
        if (this.unsubscribeCartUpdate) this.unsubscribeCartUpdate();
        if (this.gridObserver) this.gridObserver.disconnect();
      }

      refresh() {
        fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cart) => {
            this.caseQuantityInCart = cart.items
              .filter((item) => item.product_type === this.caseProductType)
              .reduce((total, item) => total + item.quantity, 0);
            this.applyState();
          })
          .catch(() => {});
      }

      applyState() {
        const showPromo = this.caseQuantityInCart === 1;
        document.querySelectorAll('.bogo-badge').forEach((badge) => {
          badge.toggleAttribute('hidden', !showPromo);
        });
        document.querySelectorAll('.price--bogo').forEach((bogoPrice) => {
          const cardInformation = bogoPrice.closest('.card-information');
          const regularPrice = cardInformation
            ? cardInformation.querySelector('.price:not(.price--bogo)')
            : null;
          if (regularPrice) regularPrice.toggleAttribute('hidden', showPromo);
          bogoPrice.toggleAttribute('hidden', !showPromo);
        });
      }
    }
  );
}
